import { MENTOR_LIST_FAIL, MENTOR_LIST_REQUEST, MENTOR_LIST_SUCCESS } from "./mentor.constants";

export const mentorListReducer = (state = { mentors: [] }, action) => {
    switch (action.type) {
        case MENTOR_LIST_REQUEST:
            return { ...state, loading: true };
        case MENTOR_LIST_SUCCESS:
            return { loading: false, success: true, mentors: action.payload };
        case MENTOR_LIST_FAIL:
            return { loading: false, error: action.payload };
        // case USER_LIST_RESET:
        //     return { users: [] };
        default:
            return state;
    }
};